<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-bullhorn"></i> Origem do contato</h3>
      </div>
    </div>
    <OriginAdd v-if="showAdd" ref="OriginAdd" v-on:Back="onBack" />
    <OriginList v-else ref="OriginList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import OriginAdd from './components/add/originadd.vue'
import OriginList from './components/list/originlist.vue'

export default {
  name: 'Origin',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    OriginAdd,
    OriginList
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  mounted () {
    Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.OriginAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
      // this.$refs.OriginList.onLoad()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/origem/origin.vue